import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { deploymentAdapter } from './deploymentsReducer';
import { DeploymentsStateModel } from './deploymentsStateModel';

const selectDeploymentState = (state: RootState): DeploymentsStateModel => state.deployments;
const selectDeploymentId = (state: RootState, id: string) => id;

export const selectIsLoadingDeployments = createSelector(
  selectDeploymentState,
  (state) => state.loading,
);

export const selectErrorsForDeployments = createSelector(
  selectDeploymentState,
  state => state.errors,
);

export const {
  selectAll: selectAllDeployments,
} = deploymentAdapter.getSelectors(selectDeploymentState);

export const selectDeploymentById = createSelector(
  [selectDeploymentState, selectDeploymentId],
  deploymentAdapter.getSelectors().selectById,
);
